export default "__VITE_ASSET__BmrqoX9Q__"